// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"571":"ba5227a7403d4ad8","587":"34d0c7899f4c03bf"}[chunkId] + ".css";
};